var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{staticClass:"music-body",on:{"click":function($event){return _vm.bindMusicChange()}}},[_c('div',{class:{'music-play':_vm.audioPlay}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }